import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/faq';
import { SectionHeading } from './SectionHeading';
import { SectionCta } from './SectionCta';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-mist px-5 py-16 sm:py-24" aria-label="Frequently asked questions" data-id="element-96" data-mp="1ge8wgqsu0lu2">
      <div className="mx-auto max-w-3xl" data-id="element-97" data-mp="2dzxvgdgl2nlu">
        <SectionHeading eyebrow="Frequently asked questions" title="Everything You Need to Know" data-id="element-98" data-mp="291mj9w2tg10g" />
        <ul className="mt-10 space-y-3" data-id="element-99" data-mp="24206toutaosp">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className="overflow-hidden rounded-2xl bg-white ring-1 ring-line" data-id="element-100" data-mp="1z2dt7eb2n6jd" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand" data-id="element-101" data-mp="so62u699r7tc">
                  <span className="font-bold leading-snug text-ink" data-id="element-102" data-mp="fk0e8zujub2v">{f.q}</span>
                  <PlusIcon className={`h-5 w-5 shrink-0 text-brand transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-103" data-mp="fm4ffa12cvzg" />
                </button>
                <AnimatePresence initial={false} data-id="element-104" data-mp="biexv4it3enx">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-105" data-mp="3sz6g1v03slke">
                      <p className="px-5 pb-5 leading-relaxed text-ink/75" data-id="element-106" data-mp="3nztk8kr9845o">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
        <SectionCta label="My questions are answered — I’m in" data-id="element-107" data-mp="1pojmqthpqpy0" />
      </div>
    </section>;
}